module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAANlBMVEUAAAAAc8gAcskAcsgAc8gAc8gAc8gAc8gAc8gAc8gAc8kAc8kAc8kAc8kAcsoAcskAc8oAc8jknDpyAAAAEXRSTlMAlTlY8/Hg0r++pWJeQz8tCdX5lKwAAAA2SURBVAjXY2Bg5meAAU5WJhiTUVCQEcEUZGGGMkGAnQnOZOODMblhCrgEINo4BHlhhvHAjAUAa/QCDOwQQ5IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_bgAfter2.png
// module id = cjTt
// module chunks = 9